import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styled from '@emotion/styled'

import {
  underlineFocus,
  FocusSpan,
} from 'portal-modules/common/components/focus-styles'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

export const StyledLink = styled(Link)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.mode.card_background_color};
  border: 1px solid ${({ theme }) => theme.blue.system_blue};
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  color: ${({ theme }) => theme.blue.system_blue};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 16px;
  font-weight: 700;
  list-style-type: none;
  padding: ${({ isfromwallet }) => (isfromwallet ? '45px 32px' : '64px 32px')};
  text-align: center;
  text-decoration: none;
  transition: all 250ms ease-out;

  ${underlineFocus}
`

const AddCard = ({ to, style, children, isfromwallet }) => (
  <StyledLink to={to} style={style} isfromwallet={isfromwallet}>
    <FocusSpan>{children}</FocusSpan>
  </StyledLink>
)

AddCard.propTypes = {
  children: PropTypes.any,
  rest: PropTypes.any,
  style: PropTypes.any,
  to: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  isFromWallet: PropTypes.bool,
}

AddCard.defaultProps = {
  isFromWallet: false,
}

export default AddCard
